import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=07977eed&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=07977eed&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07977eed",
  null
  
)

export default component.exports